import { ref, uploadBytesResumable, getBytes } from 'firebase/storage';
import { storage } from './firebase';

export const uploadFile = (file, path, onProgress) => {
  return new Promise((resolve, reject) => {
    // Create a storage reference
    const storageRef = ref(storage, path);

    // Create the file metadata
    const metadata = {
      contentType: file.type,
    };

    // Upload the file and metadata
    const uploadTask = uploadBytesResumable(storageRef, file, metadata);

    // Listen for state changes, errors, and completion of the upload
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and total
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (onProgress) {
          onProgress(progress);
        }
      },
      (error) => {
        // Handle unsuccessful uploads
        reject(error);
      },
      async () => {
        // Handle successful uploads on complete
        try {
          resolve(
            `https://storage.googleapis.com/arbitration-documents/${path}`,
            // ref: uploadTask.snapshot.ref.fullPath,
          );
        } catch (error) {
          reject(error);
        }
      },
    );
  });
};

// Function to download file from Firebase Storage using SDK (avoids CORS issues)
export const downloadFileFromStorage = async (path) => {
  try {
    const storageRef = ref(storage, path);
    const bytes = await getBytes(storageRef);
    return new Blob([bytes], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });
  } catch (error) {
    console.error('Error downloading from Firebase Storage:', error);
    throw error;
  }
};
